






































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import FilterToggle from '@/components/FilterToggle.vue'
import {ListNotasInseridasSchema} from '@/schema/resource/NotasInseridas/ListNotasInseridasSchema'
import moment from 'moment'
import {NotasInseridasFilterCollection} from '@/model/filter/NotasInseridasFilterCollection'
import NotasInseridasFilter from '@/components/filters/NotasInseridasFilter.vue'
import {NotasInseridas} from '@/model/resource/NotasInseridas'
import {NotasInseridasCollection} from '@/model/collection/NotasInseridasCollection'
import {CsvNotasInseridasSemanalSchema} from '@/schema/resource/NotasInseridas/CsvNotasInseridasSemanalSchema'

@Component({
  components: {NotasInseridasFilter, FilterToggle},
})
export default class ListNotasInseridasWeeklyView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListNotasInseridasSchema()
  collection = new NotasInseridasFilterCollection()
  filterOpen = false
  date = ''

  weeks: string[] = []

  async created() {
    await this.lastGenerationDate()
    this.collection.ano = moment().year()
    this.collection.mes = moment().month() + 1

    this.buildWeeksHeader()

    await this.collection.queryAsPage()
  }

  buildWeeksHeader() {
    this.weeks = ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4', 'Semana 5']
  }

  async lastGenerationDate() {
    await this.$await.run('getLastUpdate', async () => {
      this.date = Helper.datetime(await NotasInseridas.getLastGenerationDate())
    })
  }

  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params
    const collection = new NotasInseridasCollection()
      .clearFilters()
      .addFilter(params)
    await collection.listNotasInseridasWeekly()
    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvNotasInseridasSemanalSchema(),
      this.$t('schema.CsvNotasInseridas.titleCsvSemanal') as string
    )
  }
}
